import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  Breed,
  FindAnimalBreedData,
  FindAnimalBreedEntity,
  FindAnimalBreedError,
} from "./findAnimalBreedInterfaces";

const initialState: FindAnimalBreedEntity = {
  current: null,
  isLoading: false,
  error: null,
};

const findAnimalBreedSlice = createSlice({
  name: "findAnimalBreed",
  initialState,
  reducers: {
    findAnimalBreedStart: (
      state,
      _action: PayloadAction<FindAnimalBreedData>,
    ) => {
      state.isLoading = true;
    },

    findAnimalBreedSucceeded: (state, action: PayloadAction<Breed[]>) => {
      state.current = [...action.payload];
      state.isLoading = false;
      state.error = null;
    },

    operationFailed: (state, action: PayloadAction<FindAnimalBreedError>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  findAnimalBreedStart,
  findAnimalBreedSucceeded,
  operationFailed,
} = findAnimalBreedSlice.actions;

export const findAnimalBreed = findAnimalBreedSlice.reducer;
